// src/components/pages/Movimento/createOrEdit/tabs/CabecalhoTabPanel.js
import React from 'react';

import { Stack, Button, TextField, MenuItem } from '@mui/material';

import Checkbox from '../../../../../form/Checkbox';
import DataList from '../../../../../form/DataList';
import Input from '../../../../../form/Input';
import InputNumber from '../../../../../form/InputNumber';
import Select from '../../../../../form/Select';
import SelectEmpresa from '../../../../../form/SelectEmpresa';

import { retornaDataHora, retornaData, retornaDataHoraBr } from '../../../../../../utils/retornaDataFormatada';
import { maskCEP, formatarNumero } from '../../../../../../utils/masks';

export default function CabecalhoTabPanel(props) {
    const {
        // dados
        dados,
        empresaId,
        profile,

        // configs/contexto
        operacao,
        operacaoParametros,
        parametroPessoa,
        btnText,

        natureza,

        // entidades/datalists (state do Form)
        Administrador,
        Colaborador,
        Parceiro,
        ParceiroVinculado,

        // options
        OptionsEmpresa,
        OptionsSituacao,
        OptionsCentroCusto,
        OptionsColaborador,
        OptionsParceiro,
        OptionsParceiroVinculado,
        OptionsUF,
        OptionsMunicipios,
        OptionsAlmoxarifados,
        // options imóveis
        OptionsForma,
        OptionsPrazo,
        OptionsConta,
        OptionsAdministrador,
        enumDiaVencimento,
        enumCondominio,
        enumIPTU,
        enumContrato,
        enumEnergia,
        enumAgua,
        enumLocacao,
        // handlers
        onChange,
        onFocus,
        onBlur,

        // pedido padrão
        pedidoPadraoLoading,
        pedidosPadrao,
        onAbrirPedidoPadrao,
        handleSelecionarPedidoPadrao,
        pedidoPadraoSelecionadoUuid,
        handleSalvarPedidoPadrao,
        handleAbrirExcluirPedidoPadrao,
        // distribuição fiscal
        onAbrirDocumentosFiscais,
        documentosFiscaisLoading,
    } = props;

    const retornaDiaSemana = (diaSemana) => {
        const dias = {
            0: 'Domingo',
            1: 'Segunda',
            2: 'Terça',
            3: 'Quarta',
            4: 'Quinta',
            5: 'Sexta',
            6: 'Sábado',
        };

        return dias[Number(diaSemana)] || '';
    };

    const parceiroVaiEm = natureza?.toLowerCase() === 'saida' ? 'destinatario' : 'remetente';
    const ui = profile?.uiTabs?.cabecalho || {};
    const uiDisabled = ui.disabled || {};
    const uiReadonly = ui.readonly || {};
    const uiShow = ui.show || {};
    const usaPedidoPadrao = operacaoParametros.usaPedidoPadrao;

    const mostrarPedidoPadrao = uiShow?.pedidoPadrao && usaPedidoPadrao && !!dados?.parceiroId;

    const handlePedidoPadraoChange = (event) => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        handleSelecionarPedidoPadrao(event);
    };

    //readonly do colaboradorId
    const isBalanco = operacao?.balanco === true;

    const podeSelecionarColaborador =
        isBalanco ||
        parametroPessoa?.pessoaColaborador?.diretor ||
        parametroPessoa?.pessoaColaborador?.gerenteCompras ||
        parametroPessoa?.pessoaColaborador?.supervisorCompras;

    return (
        <>
            <div>
                {uiShow.chNFe && (
                    <Stack direction="row" spacing={1} alignItems="flex-end" flexWrap="wrap" useFlexGap>
                        <Checkbox
                            title="Por padrão o sistema usa EAN comercial, quando o fornecedor usa como padrão o EAN tributável marcar está opção"
                            text="EAN Tributável"
                            name="is_cEANTrib"
                            handleOnChange={onChange}
                            value={dados.is_cEANTrib}
                            checked={!!dados.is_cEANTrib}
                        />

                        <Input
                            text="Chave NFe"
                            name="chNFe"
                            placeholder="Chave NFe"
                            title="Chave da Nota Fiscal Eletrônica"
                            handleOnChange={onChange}
                            value={dados?.chNFe || ''}
                            inputWidth="370px"
                            readonly={true}
                        />

                        <Button
                            type="button"
                            variant="contained"
                            onClick={onAbrirDocumentosFiscais}
                            disabled={!dados?.empresaId || documentosFiscaisLoading}
                            sx={{
                                alignSelf: 'flex-end',
                                minWidth: '200px',
                                height: '36px',
                                marginBottom: '15px',

                                '@media (max-width: 600px)': {
                                    minWidth: '100%',
                                    marginBottom: 0,
                                    fontSize: '12px',
                                },
                            }}
                        >
                            Notas fiscais disponíveis
                        </Button>
                    </Stack>
                )}
            </div>
            <div>
                {uiShow.empresa && (
                    <SelectEmpresa
                        text="Empresa"
                        name="empresaId"
                        title="Selecione a empresa relacionada ao movimento"
                        options={OptionsEmpresa}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados?.empresaId ?? empresaId ?? ''}
                        required
                        notOptNull={true}
                    />
                )}
                {uiShow.datasBasicas && btnText?.toLowerCase() !== 'cadastrar' && (
                    <>
                        <Input
                            text="Data Cadastro"
                            type="datetime-local"
                            name="createdAt"
                            placeholder="última atualização"
                            title="Data de inserção do cadastro no sistema"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.createdAt && retornaDataHora(dados.createdAt)}
                            readonly={true}
                            inputWidth={'150px'}
                        />

                        <Input
                            text="Data Atualização"
                            type="datetime-local"
                            name="updatedAt"
                            placeholder="última atualização"
                            title="Data da última atualização dos dados"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.updatedAt && retornaDataHora(dados.updatedAt)}
                            readonly={true}
                            inputWidth={'150px'}
                        />
                    </>
                )}
                <Input
                    text="Data"
                    type="date"
                    name="data"
                    placeholder="Data"
                    title="Data do movimento"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados?.data && retornaData(dados.data)}
                />

                <Input
                    text="Número"
                    type="text"
                    name="numero"
                    inputWidth="100px"
                    placeholder="Número"
                    title={`Número do ${operacao?.descricao || 'Movimento'}`}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados?.numero || ''}
                    required={false}
                />
                {uiShow.serie && (
                    <Input
                        text="Série"
                        type="text"
                        name="serie"
                        inputWidth="40px"
                        placeholder="Série"
                        title={`Série da Nota Fiscal}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados?.serie || ''}
                        required={false}
                    />
                )}
                {uiShow.situacao && (
                    <>
                        <Select
                            name="situacaoId"
                            title="Define a situação do movimento"
                            text="Situação"
                            inputWidth="170px"
                            options={OptionsSituacao}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.situacaoId ?? operacaoParametros?.situacaoId ?? ''}
                            isEnum={false}
                            notOptNull={true}
                            disabled={!!operacaoParametros?.situacaoIdIsDisabled}
                        />
                    </>
                )}

                {profile?.id === 'imoveis' && btnText?.toLowerCase() === 'atualizar' && (
                    <>
                        <Checkbox
                            title="Contrato assinado o movimento não poderá ser alterado"
                            text="Assinado"
                            name="assinado"
                            handleOnChange={onChange}
                            value={dados.assinado}
                            disabled={true}
                            checked={!!dados.assinado}
                        />
                    </>
                )}
                {uiShow.centroCusto && (
                    <>
                        <Select
                            name="centroCustoId"
                            title={`Define o centro de custo do ${operacao?.descricao || 'Movimento'}`}
                            text="Centro de Custo"
                            inputWidth="200px"
                            options={OptionsCentroCusto}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.centroCustoId}
                            isEnum={false}
                            notOptNull={false}
                            disabled={!!uiDisabled.centroCustoId}
                        />
                    </>
                )}

                {uiShow.provisao && (
                    <Checkbox
                        title="Provisão no financeiro"
                        text="Provisão"
                        name="provisao"
                        handleOnChange={onChange}
                        value={dados?.provisao}
                        checked={!!dados?.provisao}
                    />
                )}

                <div>
                    {uiShow.administrador && (
                        <>
                            <DataList
                                text={ui?.labels?.labAdministrador}
                                name="Administrador.descricao"
                                placeholder={`Pesquisa ${ui?.labels?.labAdministrador}`}
                                inputWidth="350px"
                                filteredOptions={OptionsAdministrador}
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={Administrador?.descricao || ''}
                                required={false}
                            />
                        </>
                    )}
                    {uiShow.colaborador && (
                        <>
                            <DataList
                                text={ui?.labels?.labColaborador}
                                name="Colaborador.descricao"
                                placeholder={`Pesquise o ${ui?.labels?.labColaborador}`}
                                inputWidth="350px"
                                filteredOptions={OptionsColaborador}
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={Colaborador?.descricao || ''}
                                required={true}
                                readonly={!podeSelecionarColaborador}
                            />
                        </>
                    )}

                    {uiShow.comissao && (
                        <>
                            <InputNumber
                                text={'Comissão R$'}
                                type="text"
                                name="valorComissao"
                                placeholder="Valor R$"
                                inputWidth="100px"
                                title="digite o valor da comissão do contrato para o corretor em R$ (reais), será gerado apenas uma parcela de pagamento da comissão"
                                handleOnChange={onChange}
                                handleOnFocus={onFocus}
                                handleOnBlur={onBlur}
                                value={dados.valorComissao ? formatarNumero(dados.valorComissao) : ''}
                                disabled={dados.geraComissao}
                            />
                            <Checkbox
                                title="Gera comissão mensal para o corretor, precisa que o imóvel esteja com o percentual da comissão preenchido."
                                text="Comissão"
                                name="geraComissao"
                                handleOnChange={onChange}
                                value={dados.geraComissao}
                                checked={dados.valorComissao > 0 ? false : !!dados.geraComissao}
                                disabled={dados.valorComissao > 0 ? true : false}
                            />
                        </>
                    )}
                </div>
            </div>
            <div>
                <DataList
                    text={ui?.labels?.labParceiro}
                    name="Parceiro.descricao"
                    placeholder={`Pesquise o ${ui?.labels?.labParceiro}`}
                    title={`digite para pesquisar o ${ui?.labels?.labParceiro} relacionado ao ${ui?.labels?.labColaborador}`}
                    inputWidth="350px"
                    filteredOptions={OptionsParceiro}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Parceiro?.descricao || ''}
                    required={true}
                    readonly={!!uiReadonly.parceiro}
                />
                {mostrarPedidoPadrao && (
                    <Stack direction="row" spacing={1} sx={{ mt: 1, alignItems: 'center' }}>
                        {pedidosPadrao?.length > 0 && (
                            <TextField
                                select
                                size="small"
                                label="Pedido Padrão"
                                name="pedidoPadraoUuid"
                                value={pedidoPadraoSelecionadoUuid || ''}
                                onChange={(event) => {
                                    document.activeElement?.blur?.();
                                    handlePedidoPadraoChange(event);
                                }}
                                disabled={pedidoPadraoLoading}
                                sx={{ width: '350px' }}
                            >
                                <MenuItem value="">Selecione</MenuItem>

                                {pedidosPadrao.map((pedido) => (
                                    <MenuItem key={pedido.uuid} value={pedido.uuid}>
                                        {pedido.diaSemana !== null && pedido.diaSemana !== undefined
                                            ? `${retornaDiaSemana(pedido.diaSemana)} - `
                                            : ''}
                                        {pedido.descricao}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleSalvarPedidoPadrao}
                            disabled={!dados?.parceiroId || pedidoPadraoLoading}
                            sx={{ minWidth: '150px' }}
                        >
                            Salvar Padrão
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={handleAbrirExcluirPedidoPadrao}
                            disabled={!pedidoPadraoSelecionadoUuid || pedidoPadraoLoading}
                        >
                            Excluir Padrão
                        </Button>
                    </Stack>
                )}

                {uiShow.parceiroVinculado && (
                    <>
                        <DataList
                            text={ui?.labels?.labParceiroVinculado}
                            name="ParceiroVinculado.descricao"
                            placeholder={`Escolha um ${ui?.labels?.labParceiroVinculado}`}
                            inputWidth="350px"
                            filteredOptions={OptionsParceiroVinculado}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={ParceiroVinculado?.descricao || ''}
                            required={false}
                        />
                    </>
                )}
            </div>
            {uiShow.financeiroCabecalho && (
                <div>
                    {' '}
                    <Select
                        name="formaId"
                        title={`Define a forma do ${operacao?.descricao ?? ''}`}
                        text="Forma"
                        inputWidth="200px"
                        options={OptionsForma}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados?.formaId ?? ''}
                        isEnum={false}
                        notOptNull={false}
                    />
                    <Select
                        name="prazoId"
                        title={`Define o prazo do ${operacao?.descricao ?? ''}`}
                        text="Prazo"
                        inputWidth="200px"
                        options={OptionsPrazo}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados?.prazoId ?? ''}
                        isEnum={false}
                        notOptNull={false}
                    />
                    <Select
                        name="contaId"
                        title="Define a conta para o recebimento do lançamento"
                        text="Conta"
                        inputWidth="200px"
                        options={OptionsConta}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados?.contaId ?? ''}
                        isEnum={false}
                        notOptNull={false}
                    />
                </div>
            )}
            {uiShow.endereco && (
                <div>
                    <Input
                        text="CEP"
                        type="text"
                        name={`${parceiroVaiEm}CEP`}
                        inputWidth="100px"
                        placeholder="Número"
                        title={`CEP do ${operacao?.descricao || 'Movimento'}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}CEP`] ? maskCEP(dados[`${parceiroVaiEm}CEP`]) : ''}
                        required={false}
                        readonly={uiReadonly.cep}
                    />

                    <Input
                        text="Logradouro"
                        type="text"
                        name={`${parceiroVaiEm}Logradouro`}
                        inputWidth="250px"
                        placeholder="Logradouro"
                        title={`Logradouro do ${operacao?.descricao || 'Movimento'}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}Logradouro`] || ''}
                        required={false}
                        readonly={uiReadonly.logradouro}
                    />

                    <Input
                        text="Número"
                        type="text"
                        name={`${parceiroVaiEm}Numero`}
                        inputWidth="100px"
                        placeholder="Número"
                        title={`Numero do ${operacao?.descricao || 'Movimento'}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}Numero`] || ''}
                        required={false}
                        readonly={uiReadonly.numero}
                    />

                    <Input
                        text="Bairro"
                        type="text"
                        name={`${parceiroVaiEm}Bairro`}
                        inputWidth="150px"
                        placeholder="Bairro"
                        title={`Bairro do ${operacao?.descricao || 'Movimento'}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}Bairro`] || ''}
                        required={false}
                        readonly={uiReadonly.bairro}
                    />

                    <Input
                        text="Complemento"
                        type="text"
                        name={`${parceiroVaiEm}Complemento`}
                        inputWidth="250px"
                        placeholder="Complemento"
                        title={`Complemento do ${operacao?.descricao || 'Movimento'}`}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}Complemento`] || ''}
                        required={false}
                        readonly={uiReadonly.complemento}
                    />

                    <Select
                        name={`${parceiroVaiEm}UfId`}
                        title="Estado do parceiro"
                        text="UF"
                        inputWidth="150px"
                        options={OptionsUF}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}UfId`] || ''}
                        isEnum={false}
                        notOptNull={true}
                        disabled={uiReadonly.uf}
                    />

                    <Select
                        name={`${parceiroVaiEm}MunicipioId`}
                        title="Municipio do Parceiro"
                        text="Municipio"
                        inputWidth="170px"
                        options={OptionsMunicipios}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados[`${parceiroVaiEm}MunicipioId`] || ''}
                        isEnum={false}
                        notOptNull={true}
                        disabled={uiReadonly.municipio}
                    />
                </div>
            )}
            {profile?.id === 'imoveis' && (
                <div>
                    <div>
                        <InputNumber
                            text={'Caução'}
                            type="text"
                            name="caucao"
                            placeholder="Valor R$"
                            inputWidth="100px"
                            title="digite o valor da caução em R$ (reais)"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.caucao ? formatarNumero(dados.caucao) : ''}
                        />
                        <InputNumber
                            text={'Multa'}
                            type="text"
                            name="multa"
                            placeholder="Multa %"
                            inputWidth="60px"
                            title="digite o valor da multa em percentual"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.multa ? formatarNumero(dados.multa) : ''}
                        />
                        <InputNumber
                            text={'Juros'}
                            type="text"
                            name="juros"
                            placeholder="Juros %"
                            inputWidth="60px"
                            title="digite o valor do juros em percentual"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.juros ? formatarNumero(dados.juros) : ''}
                        />
                        <Select
                            name="diaVencimento"
                            title="Dia de vencimento do aluguel"
                            text="Vencimento"
                            inputWidth="90px"
                            options={enumDiaVencimento}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.diaVencimento}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Select
                            name="condominio"
                            title="Responsabilidade do condomínio"
                            text="Condomínio"
                            inputWidth="120px"
                            options={enumCondominio}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.condominio}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Select
                            name="iptu"
                            title="Responsabilidade do IPTU"
                            text="IPTU"
                            inputWidth="120px"
                            options={enumIPTU}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.iptu}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Select
                            name="contrato"
                            title="Contrato impresso em nome da pessoa escolhida"
                            text="Contrato"
                            inputWidth="120px"
                            options={enumContrato}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.contrato}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Select
                            name="energia"
                            title="Tranferi a conta de energia"
                            text="Energia"
                            inputWidth="120px"
                            options={enumEnergia}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.energia}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Select
                            name="agua"
                            title="Tranferi a conta de água"
                            text="Água"
                            inputWidth="120px"
                            options={enumAgua}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.agua}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Checkbox
                            title="O imóvel usa energia solar"
                            text="Solar"
                            name="solar"
                            handleOnChange={onChange}
                            value={dados.solar}
                            checked={!!dados.solar}
                        />
                        <Checkbox
                            title="Imóvel mobiliado, verifiar inventário"
                            text="Mobiliado"
                            name="mobiliado"
                            handleOnChange={onChange}
                            value={dados.mobiliado}
                            checked={!!dados.mobiliado}
                        />
                    </div>
                    <div>
                        <Select
                            name="locacao"
                            title="Tipo de locação do imóvel"
                            text="Locação"
                            inputWidth="120px"
                            options={enumLocacao}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.locacao}
                            isEnum={true}
                            notOptNull={false}
                        />
                        <Input
                            text={'Evento'}
                            type="text"
                            name="evento"
                            placeholder="Evento"
                            inputWidth="400px"
                            title="Caso a locação seja para um evnto digitar a descrição do evento"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.evento}
                            readonly={dados.locacao !== 'Eventos' ? true : false}
                        />
                        <Input
                            text="Data Entrada"
                            type="datetime-local"
                            name="entrada"
                            placeholder="Entrada"
                            title="Data de liberação do imóvel ao locador"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.entrada}
                            readonly={false}
                            inputWidth={'150px'}
                        />
                        <Input
                            text="Data Saída"
                            type="datetime-local"
                            name="saida"
                            placeholder="Saída"
                            title="Data de devolução do imóvel ao locatário"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.saida}
                            readonly={false}
                            inputWidth={'150px'}
                        />
                    </div>
                </div>
            )}
            {profile?.id === 'serav' && (
                <div>
                    <div>
                        <InputNumber
                            text={'Multa'}
                            type="text"
                            name="multa"
                            placeholder="Multa %"
                            inputWidth="60px"
                            title="digite o valor da multa em percentual"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.multa ? formatarNumero(dados.multa) : ''}
                        />
                        <InputNumber
                            text={'Multa Diária'}
                            type="text"
                            name="multaDiaria"
                            placeholder="Multa ao dia"
                            inputWidth="60px"
                            title="digite o valor da multa aplica por dia de atraso"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.multaDiaria ? formatarNumero(dados.multaDiaria) : ''}
                        />
                        <InputNumber
                            text={'Juros'}
                            type="text"
                            name="juros"
                            placeholder="Juros %"
                            inputWidth="60px"
                            title="digite o valor do juros em percentual"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.juros ? formatarNumero(dados.juros) : ''}
                        />
                        <Input
                            text="Início"
                            type="datetime-local"
                            name="entrada"
                            placeholder="Entrada"
                            title="Data de início dos serviços"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.entrada && retornaDataHora(dados.entrada)}
                            readonly={false}
                            inputWidth={'150px'}
                        />
                        <Input
                            text="Término"
                            type="datetime-local"
                            name="saida"
                            placeholder="Saída"
                            title="Data detérmino dos serviços"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.saida && retornaDataHora(dados.saida)}
                            readonly={false}
                            inputWidth={'150px'}
                        />
                    </div>
                </div>
            )}
            <div>
                {uiShow.almoxarifado && (
                    <>
                        <Select
                            name="almoxarifadoId"
                            title="Almoxarifado padrão para todos os produtos, caso não escolha o almoxarifado será o definido no produto"
                            text="Almoxarifado"
                            inputWidth="200px"
                            options={OptionsAlmoxarifados}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.almoxarifadoId ?? ''}
                            isEnum={false}
                            notOptNull={false}
                        />
                    </>
                )}
                {uiShow.volumes && (
                    <>
                        <Input
                            text="Volumes"
                            type="text"
                            name="volumes"
                            inputWidth="100px"
                            placeholder=""
                            title="Volumes do movimento, quantidade total de caixas, fardos etc."
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.volumes}
                            required={false}
                            textAlign="center"
                        />
                    </>
                )}
                {uiShow.dataPrevista && (
                    <>
                        <Input
                            text="Data Prevista"
                            type="datetime-local"
                            name="dataPrevista"
                            placeholder="Data"
                            title="Data prevista para entrega ou recebimento dos bens/serviços"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados?.dataPrevista && retornaDataHora(dados.dataPrevista)}
                        />
                    </>
                )}
            </div>
        </>
    );
}
